export default "__VITE_ASSET__Bw5Bk1sR__"